var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('static-page-content',{attrs:{"uri":"/static/pages/overview"}}),_vm._v(" "),_c('static-page-content',{attrs:{"uri":"/static/pages/demos-bc-artist"}}),_vm._v(" "),_c('bc-artist',{class:['mt-4'],attrs:{"artist":_vm.$config.methods.album.artist}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469be340","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = null
// module chunks = 